import React from "react";
import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { ContactForm } from "@/components/ContactBlock";
import { useContent } from "@/lib/api";

export function SimplePage({ slug }) {
  const { data } = useContent();
  const s = data?.settings || {};
  const page = data?.pages?.[slug];
  if (!data) return null;
  if (!page) return null;
  return (
    <main className="wrap" style={{ paddingTop: 160, paddingBottom: 96 }} data-testid={`page-${slug}`}>
      <Seo
        title={page.seoTitle}
        description={page.seoMeta}
        path={`/${slug}/`}
      />
      <h1 className="t-h1" style={{ margin: 0, fontSize: "clamp(34px,5vw,72px)", maxWidth: 1000 }}>{page.h1}</h1>
      <div style={{ maxWidth: 820 }}>
        {page.sections.map((sec, i) => (
          <Reveal key={i}>
            <section style={{ borderTop: "1px solid var(--li)", marginTop: 52, paddingTop: 38 }}>
              <h2 className="t-h3" style={{ margin: "0 0 18px", fontSize: 26 }}>{sec.h2}</h2>
              {sec.body.map((p, j) => (
                <p className="t-body" key={j} style={{ marginTop: j === 0 ? 0 : 16 }}>{p}</p>
              ))}
            </section>
          </Reveal>
        ))}
      </div>
    </main>
  );
}

export function PlateformePage() {
  const { data } = useContent();
  const s = data?.settings || {};
  const page = data?.pages?.plateforme;
  if (!data || !page) return null;
  return (
    <main className="wrap" style={{ paddingTop: 160, paddingBottom: 96 }} data-testid="page-plateforme">
      <Seo
        title={page.seoTitle}
        description={page.seoMeta}
        path="/plateforme/"
      />
      <p className="t-label" style={{ marginBottom: 20 }}>Ouverture — janvier 2027</p>
      <h1 className="t-h1" style={{ margin: 0, fontSize: "clamp(34px,5vw,72px)", maxWidth: 1000 }}>{page.h1}</h1>
      <div style={{ maxWidth: 820 }}>
        {page.sections.map((sec, i) => (
          <Reveal key={i}>
            <section style={{ borderTop: "1px solid var(--li)", marginTop: 52, paddingTop: 38 }}>
              <h2 className="t-h3" style={{ margin: "0 0 18px", fontSize: 26 }}>{sec.h2}</h2>
              {sec.body.map((p, j) => (
                <p className="t-body" key={j} style={{ marginTop: j === 0 ? 0 : 16 }}>{p}</p>
              ))}
            </section>
          </Reveal>
        ))}
      </div>
      <div style={{ marginTop: 64, background: "var(--pp2)", padding: "48px 40px", maxWidth: 720 }}>
        <p className="t-label" style={{ marginBottom: 24 }}>Liste d'attente</p>
        <ContactForm contactSec={s.contactSec} type="plateforme" compact titreBouton="Rejoindre la liste d'attente" />
      </div>
    </main>
  );
}

export function NotFound() {
  /* Une URL qui ne se résout en aucun contenu : pas d'indexation, pas de canonique
     héritée du HTML servi, aucune explication technique affichée. */
  React.useEffect(() => {
    document.title = "Page introuvable | SLIZ";
    let robots = document.head.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "noindex");
    document.head.querySelectorAll('link[rel="canonical"]').forEach((el) => el.remove());
    return () => robots.remove();
  }, []);

  return (
    <main className="wrap" style={{ paddingTop: 180, paddingBottom: 120 }} data-testid="not-found-page">
      <h1 className="t-h1">Page introuvable.</h1>
      <p className="t-body" style={{ marginTop: 24, maxWidth: 620 }}>
        Cette adresse ne correspond à aucune page du site.
      </p>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 16, marginTop: 32 }}>
        <Link to="/" className="btn" data-testid="notfound-home-link">Retour à l'accueil</Link>
        <a href="/estimer/" className="btn" data-testid="notfound-estimer-link">Estimer ma campagne</a>
      </div>
    </main>
  );
}
